export default __webpack_public_path__ + "static/media/Monopattino3.5286f33a.jpg";